import { useRouter } from "next/router";
import Script from "next/script";

import localeCore from "../../core/locale.core";
import loginCore from "../../core/login.core";

export default function GoogleLogin() {
  const router = useRouter();

  if (!router.isReady) return null;
  const locale = localeCore.getFacebookLocale(router.locale!);

  async function render() {
    google.accounts.id.initialize({
      client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
      callback: handleCredentialResponse,
    });

    // Style Customization
    // https://developers.google.com/identity/gsi/web/reference/js-reference
    google.accounts.id.renderButton(document.getElementById("google-signin"), {
      shape: "rectangular",
      theme: "outline",
      size: "large",
      text: "signin_with",
      type: "standard",
      locale,
    });
  }

  function handleCredentialResponse(response) {
    loginCore.setGoogleLoginTokenToStore(response.credential);
    router.push("/");
  }

  return (
    <>
      <Script
        id="gsi-script"
        src={`https://accounts.google.com/gsi/client`}
        onReady={() => {
          render();
        }}
      />
      <div id="google-signin"></div>
    </>
  );
}
